// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { useEffect, useState } from 'react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { animateScroll as scroll } from 'react-scroll';
import { NAVIGATION_TOP_OFFSET } from './components/Navigation';
import {
  Events,
  scrollSpy,
} from 'react-scroll';

import { actionCreatorsList } from '../../redux/rootActionCreator';
import { CreditMethod, LabInformation, RunningLab } from '../../types/Model';
import axios from 'axios';

const {
  sendVisitedChallengeActions,
  getChallengeInformationActions,
  buyChallengeActions,
  endChallengeActions,
  updateRunningChallengeAction,
} = actionCreatorsList;

export function useLoadChallengeScroll(markdowns: string[]): void {
  useEffect(() => {
    const item = localStorage.getItem('challengeScrollY');
    if (item !== null && markdowns.length > 0) {
      const scrollY = JSON.parse(item);
      scroll.scrollTo(scrollY, { delay: 1000, offset: NAVIGATION_TOP_OFFSET });
    }
  }, [markdowns]);
}

export function useSaveChallengeScroll(markdowns: string[]): void {
  useEffect(() => {
    function handleScrollEvent() {
      if (markdowns.length > 0) {
        localStorage.setItem('challengeScrollY', JSON.stringify(window.scrollY));
      }
    }

    window.addEventListener('scroll', handleScrollEvent);

    return () => {
      window.removeEventListener('scroll', handleScrollEvent);
    };
  }, [markdowns]);
}

export function parseMarkdown(markdown: string): string[] {
  const parsed: string[] = markdown
    .split('\n## ')
    .slice(1)
    .map(s => '## ' + s)
    .map(s => s.trim())
    .reduce((fin: string[], cur: string): string[] => {
      if (fin.length > 0) {
        const last = fin.pop() || '';
        // check for dangling fenced code block
        if ((last.match(/```/g) || []).length % 2 === 1) {
          // merge it with last paragraph
          return fin.concat(last.concat(cur));
        } else {
          fin.push(last);
          return fin.concat(cur);
        }
      } else {
        return fin.concat(cur);
      }
    }, [])

  return parsed;
}

export function useMarkdowns(challenge: LabInformation, isFetchingChallenge: boolean, navigationFocus: any): [string[], boolean] {
  const [markdowns, setMarkdowns] = useState<string[]>([]);
  const [isMarkdownFetching, setIsMarkdownFetching] = useState(false);

  useEffect(() => {
    if (challenge?.runningInfo?.markdownUrl && !isFetchingChallenge) {
      setIsMarkdownFetching(true);
      const url = `${challenge.runningInfo.markdownUrl}/${navigationFocus}`
      // console.log(url);
      axios.get(url, { withCredentials: true })
        .then((result) => {
          const markdown: string = result.data;
          const parsed: string[] = parseMarkdown(markdown)
          setMarkdowns(parsed);
          // console.log(parsed);
          setIsMarkdownFetching(false);
        })
        .catch(() => {
          setMarkdowns([])
          setIsMarkdownFetching(false);
        });
    } else {
      setMarkdowns([]);
    }
  }, [challenge?.runningInfo?.markdownUrl, isFetchingChallenge]);

  return [markdowns, isMarkdownFetching];
}

export function useFetchChallengeInformation(id: number, { workshopId, callback, preventLoading, iltCourseId }: { workshopId?: number; iltCourseId?: number; callback?: () => void; preventLoading?: boolean }): () => void {
  const dispatch = useDispatch();
  const fetch = useCallback(() => {
    dispatch(getChallengeInformationActions.request({ id, condition: 'Buy', workshopId, iltCourseId, preventLoading }));
    callback && callback();
  }, [id, workshopId, callback]);

  return fetch;
}

interface BuyChallengeOption {
  creditMethod: CreditMethod,
  workshopId?: number;
  courseId?: number;
  iltCourseId?: number;
  success?: () => void;
  onError?: (error: string) => void;
}

export function useBuyChallenge(id: number, { creditMethod, workshopId, courseId, iltCourseId, success, onError }: BuyChallengeOption): () => void {
  const dispatch = useDispatch();
  const buyChallenge = useCallback(() => {
    dispatch(buyChallengeActions.request({
      id,
      creditMethod,
      workshopId,
      courseId,
      iltCourseId,
      success,
      onError,
    }));
  }, [id, workshopId, courseId, iltCourseId, success, onError])

  return buyChallenge;
}

export function useTestChallenge(id: number, { success, onError }: { success?: () => void; onError?: (error: string) => void }): () => void {
  const dispatch = useDispatch();
  const testChallenge = useCallback(() => {
    dispatch(buyChallengeActions.request({
      id,
      test: true,
      success,
      onError,
    }))
  }, [id, success, onError]);

  return testChallenge;
}

export function useEndChallenge(id: number, callback?: () => void): () => void {
  const dispatch = useDispatch();

  const endChallenge = useCallback(() => {
    dispatch(endChallengeActions.request({
      id,
      callback,
    }))
  }, [id, callback]);

  return endChallenge;
}

export function useUpdateRunningChallenge(): (runningChallenge: Partial<RunningLab>) => void {
  const dispatch = useDispatch();

  const updateRunningChallenge = useCallback((runningChallenge: Partial<RunningLab>) => {
    dispatch(updateRunningChallengeAction(runningChallenge));
  }, []);

  return updateRunningChallenge;
}

export function useIsNavigationScrolling(): boolean {
  const [isNavigationScrolling, setIsNavigationScrolling] = useState(false);

  useEffect(() => {
    Events.scrollEvent.register('begin', () => {
      setIsNavigationScrolling(true);
    });

    Events.scrollEvent.register('end', () => {
      localStorage.setItem('challengeScrollY', JSON.stringify(window.scrollY))
      setIsNavigationScrolling(false);
    });

    scrollSpy.update();

    return () => {
      Events.scrollEvent.remove('begin');
      Events.scrollEvent.remove('end');
    };
  }, []);

  return isNavigationScrolling;
}

export const useSendVisitChallenge = (id: number): () => void => {
  const visitedChallenges: number[] = JSON.parse(localStorage.getItem('visitedChallenges') || '[]');
  const dispatch = useDispatch();

  return useCallback(() => {
    if (visitedChallenges) {
      if (visitedChallenges.indexOf(id) === -1) {
        const newVisitedCourse = [...visitedChallenges, id];
        dispatch(sendVisitedChallengeActions.request({
          id
        }))
        localStorage.setItem('visitedChallenges', JSON.stringify(newVisitedCourse));
      }
    } else {
      const newVisitedCourse = [id];
      dispatch(sendVisitedChallengeActions.request({
        id
      }))
      localStorage.setItem('visitedChallenges', JSON.stringify(newVisitedCourse));
    }
  }, [id])
}
